export default {
  init() {
    // JavaScript to be fired on the savings detail page
    
    // Checks if NM user //
    $.ajax({
      url: '/rrtpbillcompare/Servlet?type=is-netmeter&account=' + $('#account').val(), 
      success: function(data) {
        //console.log('is-netmeter');
        //console.log(data); //Veracode #653 - best to hide code
        if(data == 'rider1'){
          result = $('.netmetering').css('display','table-row');
        } else if (data == 'rider19'){
          $('.netmetering').css('display','table-row');
          $('.communityGen').css('display','table-row');
        } else if (data == 'rider9'){
          $('.communityGen').css('display','table-row');
        } else if (data == 'rider5'){
          $('.rider5').css('display','table-row');
        }
        else{
          //console.log(data); //Veracode #610 - best to hide code
        }
      },
      cache: false,
      async: false,
    });

    function getParameterByName(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
      results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }	
    
    // make global, since webpack uses enclosures to scope partials
    window.mhpa = window.mhpa || {};
    window.mhpa.loadAccountData = function(account) {

      var account = getParameterByName('account');
      $('#accountStatic').text(account);
      //console.log('/rrtpbillcompare/Servlet?type=bill-grid&date=' + getParameterByName('date') + '&account=' + getParameterByName('account'));
      $.getJSON('/rrtpbillcompare/Servlet?type=bill-grid&date=' + getParameterByName('date') + '&account=' + getParameterByName('account'), function( data ) {
        //console.log(data); //Veracode #663 - best to hide code
        jQuery.each(data, function(i, val) {
          //$('#' + i).html(val);
          if ($.inArray(i, ['totalElectrictySupplyServicesRRTP','totalElectrictySupplyServicesSTD','totalElectrictySupplyServicesSavings','totalDeliveryServicesRRTP','totalDeliveryServicesSTD','totalDeliveryServicesSavings','totalTaxesAndOtherRRTP','totalTaxesAndOtherSTD','totalTaxesAndOtherSavings','totalCurrentChargesRRTP','totalCurrentChargesSTD','totalCurrentChargesSavings']) !== -1) {
            $('#' + i).html('<strong>'+val+'</strong>');
          } else {
            $('#' + i).html(val);
          }
        });
      });

      // Only show April 2023 disclaimer lanugage between Wed Mar 15 2023 00:00:00 and Mon May 15 2023 00:00:00 localtime
      if (parseFloat(getParameterByName('date')) > 1678856400000 && parseFloat(getParameterByName('date')) < 1684126800000) {
        $('#deferred-prosecurtion-agreement-april-2023').show();
      } else {
        $('#deferred-prosecurtion-agreement-april-2023').hide();
      }
    }
    mhpa.loadAccountData();

    // buttons
    $('#butPrint').click(function() {
      window.print();
    });
  },
  finalize() {
    // JavaScript to be fired on the savings detail page, after the init JS
  },
};
